<template>
  <Modal>
    <Modal.Media>
      <img
        :src="AddRegistrationTipImage"
        :width="TIP_IMAGE_WIDTH"
        :height="TIP_IMAGE_HEIGHT"
        alt=""
        class="transition-opacity duration-200"
        :class="imageLoaded ? 'opacity-100' : 'opacity-0'"
        @load="imageLoaded = true"
      />
    </Modal.Media>

    <Modal.Title>Add your first registration</Modal.Title>
    <Modal.Body>
      Just drag and drop or select upload. It’s that simple.
    </Modal.Body>

    <Modal.Footer>
      <Button
        variant="primary"
        :size="isMobile ? 'lg' : 'md'"
        @click="closeModal()"
      >
        Okay
      </Button>
    </Modal.Footer>
  </Modal>
</template>

<script setup lang="ts">
import { onBeforeUnmount, ref } from 'vue'
import { Modal, Button } from '@dacr/library'

import AddRegistrationTipImage from '@/assets/images/add-registration-tip.png'
import { useDevice } from '@/shared/composables/useDevice'
import { closeModal } from '@/shared/dialogs/modals'
import {
  GuidanceActionState,
  GuidanceId,
  MeDocument,
  useUpdateGuidanceMutation,
  type MeQuery,
} from '@/shared/graphql/legacy/generated'

const TIP_IMAGE_WIDTH = 1464
const TIP_IMAGE_HEIGHT = 762

const { isMobile } = useDevice()

const imageLoaded = ref(false)

const { mutate: updateGuidance } = useUpdateGuidanceMutation()

onBeforeUnmount(() => {
  updateGuidance(
    {
      input: {
        id: GuidanceId.WelcomeModal,
        action: GuidanceActionState.Completed,
      },
    },
    {
      update(cache, { data }) {
        cache.updateQuery<MeQuery>({ query: MeDocument }, (response) => {
          if (!response || !data?.guidance) return

          return {
            ...response,
            me: {
              ...response.me,
              guidanceStates: data.guidance,
            },
          }
        })
      },
    }
  ).catch(() => undefined)
})
</script>
